import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_STOCK_FUNDAMENTAL_LIST_API_ID =
  'DASHBOARD/FETCH_STOCK_FUNDAMENTAL_LIST_API_ID';

const apiCall = createApiCall(FETCH_STOCK_FUNDAMENTAL_LIST_API_ID, params => ({
  endpoint: generateEndpoint({
    host: `/api/admin/stock-fundamentals`,
    params: (params as unknown) as Record<string, any>,
  }),
  method: 'GET',
}));

export default apiCall;
